export default __webpack_public_path__ + "static/media/personal-rent-icon.40507efd.svg";